export default __webpack_public_path__ + "static/media/window-maximize-regular.315228e3.svg";